import productGetters from "../getters/productGetters";
const bundleProductInitialSelector = (bundles) => Array.isArray(bundles) ? bundles.reduce((acc, curr) => {
  const isMultiple = ["checkox", "multi"].includes(curr.type);
  if (isMultiple) {
    const defaultValues = curr.options.filter((o) => o.is_default && o.product);
    if (defaultValues.length > 0) {
      acc[curr.uid] = defaultValues.map((value) => {
        const price = productGetters.getPrice(value.product);
        return {
          uid: value.uid,
          quantity: value.quantity || 1,
          price: price.special < price.regular && price.special !== null ? price.special : price.regular
        };
      });
    }
  } else {
    const defaultValue = curr.options.find((o) => o.is_default && o.product);
    if (defaultValue) {
      const price = productGetters.getPrice(defaultValue.product);
      acc[curr.uid] = {
        uid: defaultValue.uid,
        quantity: defaultValue.quantity || 1,
        price: price.special < price.regular && price.special !== null ? price.special : price.regular
      };
    }
  }
  return acc;
}, {}) : {};
export {
  bundleProductInitialSelector
};
